document.addEventListener("DOMContentLoaded", function() {
  const ids = ['overview','features','specs','review'];
  const tabContentIds = ids.map(item => `zwo_product_tab_${item}`);
  const tabsContainer = document.querySelector(".zwo_product_tabs");
  const tabs = tabsContainer.querySelectorAll("div");
  // 根据tabContentIds 获取tabContent
  const tabContents = tabContentIds.map(item => {
    return document.querySelector(`#${item}`);
  })
  const topOffset = 64; // 固定 tabs 高度

  // 获取 tabs 初始文档位置
  let initialOffset = tabsContainer.getBoundingClientRect().top + window.scrollY;

  window.addEventListener("load", () => {
    initialOffset = tabsContainer.getBoundingClientRect().top + window.scrollY;
    syncTabsVisibility();
  });

  function updateTabsFixed() {
    // 因为滚动到临界点之后 fixed tabs 的高度会变化，所以需要重新计算初始位置, 加20的偏移量是为了避开 fixed tabs 的遮挡
    if (window.scrollY + topOffset + 20 >= initialOffset) {
      tabsContainer.classList.add("fixed");
    } else {
      tabsContainer.classList.remove("fixed");
    }
  }

  window.addEventListener("scroll", updateTabsFixed);
  window.addEventListener("resize", updateTabsFixed);

  updateTabsFixed();
  if(!tabs.length) {
    tabsContainer.style.display = "none";
  }
  function syncTabsVisibility() {
    let visibleCount = 0;

    tabs.forEach(tab => {
      const raw = tab.dataset.target || "";
      const targetId = raw.replace(/^#/, "");
      const targetEl = document.getElementById(targetId);

      if (targetEl) {
        tab.style.display = "";
        visibleCount++;
      } else {
        tab.style.display = "none";
      }
    });

    // 如果没有任何tab可见，就隐藏整个容器
    if (visibleCount === 0) {
      tabsContainer.style.display = "none";
    } else {
      tabsContainer.style.display = "";
    }
  }

  syncTabsVisibility();
  
  if(tabs && tabs.length) {
    const fistTab = tabs[0];
    fistTab.classList.add("active");
  }
  tabs.forEach(tab => {
    const targetTabId = tab.dataset.target.replace('#','')
    const targetEl = document.getElementById(targetTabId)
    if (!targetEl) {
      tab.style.display = 'none'
    }
    tab.addEventListener("click", function() {
      tabs.forEach(t => t.classList.remove("active"));
      this.classList.add("active");

      const targetId = this.dataset.target.replace('#','');
      tabContents.forEach(block => {
        block.style.display = (block.id === targetId) ? 'block' : 'none';
        block.style.paddingTop = (block.id === targetId) ? `${64}px` : '0px';
      });

      // 强制滚动到新内容顶部，保证内容不会被 fixed tabs 遮挡
      requestAnimationFrame(() => {
        const targetContent = document.getElementById(targetId);
        const scrollToY = targetContent.offsetTop - topOffset;
        window.scrollTo({ top: scrollToY, behavior: 'auto' });
      });
    });
  });
});